import React from 'react';
import { CodeBlock } from 'react-code-block';
import { useCopyToClipboard } from 'react-use';
import '@fortawesome/fontawesome-svg-core/styles.css';
import YouTube from "react-youtube";

function LegoL95Component({ code, language }) {
    code = `{/* L95 4 horizontal color boxes with titles */}
                                    <div className="lego l095">
                                        <div className="contentBox box1">
                                            <p>ACUPUNCTURE</p>
                                        </div>
                                        <div className="contentBox box2">
                                            <p>PHYSICAL THERAPY</p>
                                        </div>
                                        <div className="contentBox box3">
                                            <p>NUTRITIONAL COUNSELING</p>
                                        </div>
                                        <div className="contentBox box4">
                                            <p>MEDICAL MASSAGE</p>
                                        </div>
                                    </div>
                                    {/* L95 4 horizontal color boxes with titles */}`;
    language = 'jsx';
    const [state, copyToClipboard] = useCopyToClipboard();

    const copyCode = () => {
        // Logic to copy `code`
        copyToClipboard(code);
    };

    return (
        <CodeBlock code={code} language={language}>
            <div className="relative">
                <CodeBlock.Code className="bg-black">
                    <div className="table-row">
                        <CodeBlock.LineNumber className="table-cell pr-4 text-sm text-gray-500 text-right select-none" />
                        <CodeBlock.LineContent className="table-cell">
                            <CodeBlock.Token />
                        </CodeBlock.LineContent>
                    </div>
                </CodeBlock.Code>
                <div className="buttonContainer">
                    <button className="btn btn-primary ml-auto" onClick={copyCode}>
                        <i className="fa-solid fa-copy"></i> {state.value ? 'Copied!' :  'Copy code'}
                    </button>
                </div>
            </div>
        </CodeBlock>
    );
}

export default LegoL95Component;